module.exports = __webpack_public_path__ + "static/media/admin-heading.c8d74832.svg";